import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageLocationsComponent } from "./manage-locations.component";

const routes: Routes = [
  {
    path: '',
    component: ManageLocationsComponent,
    children: [
      {
        path: '404',
        component: ManageLocationsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageLocationsRoutingModule {
}
